import { localize } from '@vee-validate/i18n'
import en from '@vee-validate/i18n/dist/locale/en.json'
import {
    required,
    email,
    min,
    max,
    numeric,
    min_value,
    max_value,
    url,
    length,
    confirmed,
    alpha_num
} from '@vee-validate/rules'
import { defineRule, configure } from 'vee-validate'

defineRule('numeric', numeric)
defineRule('required', required)
defineRule('email', email)
defineRule('min', min)
defineRule('max', max)
defineRule('min_value', min_value)
defineRule('max_value', max_value)
defineRule('url', url)
defineRule('length', length)
defineRule('confirmed', confirmed)
defineRule('alpha_num', alpha_num)

// this rule is intended to check that if the first input is filled, the second input must become required
defineRule('required_by_other_input', (value: string, params: [string]) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return !(value.length === 0 && params.length === 1 && params[0].length > 0)
})

defineRule('at_least_one_special_character', (value: string) => {
    const re = /[\W_]/g
    return re.test(value)
})

defineRule('at_least_one_uppercase', (value: string) => {
    const re = /[A-Z]/g
    return re.test(value)
})

defineRule('at_least_one_digit', (value: string) => {
    const re = /\d/g
    return re.test(value)
})

defineRule('no_spaces', (value: string) => {
    const re = /^\S+$/
    return re.test(value)
})

defineRule('alpha_num_special_chars', (value: string): boolean => {
    const re = /^[a-zA-Z0-9._/-]*$/
    return re.test(value)
})

defineRule('alpha_num_with_spaces', (value: string) => {
    const re = /^[a-zA-Z0-9 ]*$/
    return re.test(value)
})

defineRule('http_url', (value: string) => {
    const re = /^https?:\/\/.*/
    return re.test(value)
})

defineRule('json', (value: string) => {
    try {
        if (value.length > 0) JSON.parse(value)
        return true
    } catch(error) {
        return false
    }
})

defineRule('date_after_now', (value: string | Date) => {
    const now = new Date()
    const selectedDate = new Date(value)

    return selectedDate > now
})

configure({
    generateMessage: localize({
        en: {
            messages: en.messages
        }
    })
})

configure({
    generateMessage: localize({
        en: {
            messages: {
                at_least_one_uppercase: 'The {field} must contain at least one capital letter',
                at_least_one_digit: 'The {field} must contain at least one number',
                at_least_one_special_character: 'The {field} must contain at least one special character',
                username: 'The {field} can contain only letters and numbers',
                http_url: 'The {field} must be valid URL',
                date_after_now: 'The {field} must be a future date',
                domain: 'The {field} is not valid domain'
            }
        }
    })
})
